import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { LocaleService } from '@sm360/widget-commons-core-services';
import { PurchaseMethods, ModelYear } from '@sm360/widget-commons-vehicle';
import { AnalyticsService, TRACKING_TAGS as TAGS } from '@sm360/widget-commons-general';

import PurchaseMethodsTabControlHeader from 'payment-calculator/components/PurchaseMethodsTabControl/PurchaseMethodsTabControlHeader.jsx';
import PaymentCalculatorDetails from 'payment-calculator/components/PaymentCalculatorDetails/PaymentCalculatorDetails.jsx';

import * as Actions from 'payment-calculator/actions/paymentCalculatorActions.js';
import PaymentBar from 'payment-calculator/components/PaymentBar/PaymentBar.jsx';

class PaymentCalculatorDisplay extends React.Component {
    constructor(props) {
        super(props);
        this.setScrollTopToZero = this.setScrollTopToZero.bind(this);
        this.handlePurchaseMethodChange = this.handlePurchaseMethodChange.bind(this);
    }

    componentWillReceiveProps(newProps) {
        this.calculator = this.setScrollTopToZero(this.props, newProps, this.calculator);
    }

    setScrollTopToZero(oldProps, newProps, calculator) {
        const newCalculator = { ...calculator };
        if (!oldProps.frequenciesPanelOpen && newProps.frequenciesPanelOpen && calculator) {
            newCalculator.scrollTop = 0;
        }
        return newCalculator;
    }

    handlePurchaseMethodChange(value) {
        this.props.actions.selectPurchaseMethod(value);
        AnalyticsService.ga4Trigger(
            TAGS.PAYMENT_CALCULATOR_TYPE(value, this.props.modelYear.model, this.props.modelYear.year)
        );
    }

    areTermsAvailable(terms) {
        return terms.length > 0 && terms.some((term) => term.term !== 0);
    }

    render() {
        const purchaseMethods = this.props.purchaseMethods;

        const currentButton = !this.props.hasCustomButton && (
            <PaymentBar
                setMobilePaymentCalculatorOpened={this.props.handleFrequenciesPanel}
                selectedFinanceTerm={purchaseMethods.getSelectedFinanceTerm()}
                paymentFrequencyLabels={purchaseMethods.getPaymentFrequencyLabels(false, LocaleService)}
                taxesIncluded={purchaseMethods.taxesIncluded}
                taxCodes={purchaseMethods.taxCodes}
                frequenciesPanelOpen={this.props.frequenciesPanelOpen}
                displayCreditRate={this.props.displayCreditRate}
            />
        );

        return (
            <div>
                {currentButton}
                <div
                    className={this.props.panelFrequenciesClassNames.join(' ')}
                    ref={(calculator) => {
                        this.calculator = calculator;
                    }}
                >
                    <PurchaseMethodsTabControlHeader
                        leaseAvailable={this.areTermsAvailable(purchaseMethods.lease.terms)}
                        financeAvailable={this.areTermsAvailable(purchaseMethods.finance.terms)}
                        leaseSelected={purchaseMethods.lease.selected}
                        financeSelected={purchaseMethods.finance.selected}
                        cashPurchaseSelected={purchaseMethods.cashPurchase.selected}
                        selectPurchaseMethod={this.handlePurchaseMethodChange}
                    />
                    <PaymentCalculatorDetails
                        closePanel={this.props.handleFrequenciesPanel}
                        displayCreditRate={this.props.displayCreditRate}
                    />
                </div>
            </div>
        );
    }
}

PaymentCalculatorDisplay.propTypes = {
    purchaseMethods: PropTypes.instanceOf(PurchaseMethods.PurchaseMethodsModel).isRequired,
    modelYear: PropTypes.instanceOf(ModelYear.ModelYearModel).isRequired,
    handleFrequenciesPanel: PropTypes.func.isRequired,
    actions: PropTypes.shape({
        selectPurchaseMethod: PropTypes.func.isRequired,
        saveTradeInVehicle: PropTypes.func.isRequired,
    }),
    panelFrequenciesClassNames: PropTypes.arrayOf(PropTypes.string),
    frequenciesPanelOpen: PropTypes.bool.isRequired,
    hasCustomButton: PropTypes.bool.isRequired,
    displayCreditRate: PropTypes.bool,
};

PaymentCalculatorDisplay.defaultProps = {
    actions: [],
    panelFrequenciesClassNames: [],
    displayCreditRate: false,
};

PaymentCalculatorDisplay.displayName = 'PaymentCalculatorDisplay';

function mapStateToProps(state) {
    return {
        purchaseMethods: state.purchaseMethods,
        modelYear: state.modelYear,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Actions, dispatch),
    };
}

export { PaymentCalculatorDisplay };
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(PaymentCalculatorDisplay);
